export enum PlatformType {
    IOS = "iOS",
    ANDROID = "Android",
    PC = "PC",
    OFFICEONLINE = "OfficeOnline",
    MAC = "Mac",
    UNIVERSAL = "Universal"
}